// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

:root {
  --bg: #0a0c10;
  --bg-card: #111318;
  --bg-hover: #1a1d24;
  --border: #1f2330;
  --text: #e8eaf0;
  --text-muted: #6b7280;
  --text-dim: #9ca3af;
  --accent: #4f8ef7;
  --accent-hover: #3b7df6;
  --accent-dim: rgba(79, 142, 247, 0.12);
  --success: #34d399;
  --warning: #fbbf24;
  --danger: #f87171;
  --font: 'DM Sans', sans-serif;
  --mono: 'DM Mono', monospace;
  --radius: 8px;
  --radius-lg: 12px;
}

body {
  font-family: var(--font);
  background: var(--bg);
  color: var(--text);
  font-size: 14px;
  line-height: 1.6;
  -webkit-font-smoothing: antialiased;
}

a { color: inherit; text-decoration: none; }
button { cursor: pointer; font-family: var(--font); }
input { font-family: var(--font); }
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,yBAAyB,sBAAsB,EAAE,SAAS,EAAE,UAAU,EAAE;;AAExE;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;EACvB,sCAAsC;EACtC,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;EAC7B,4BAA4B;EAC5B,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA,IAAI,cAAc,EAAE,qBAAqB,EAAE;AAC3C,SAAS,eAAe,EAAE,wBAAwB,EAAE;AACpD,QAAQ,wBAAwB,EAAE","sourcesContent":["*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }\n\n:root {\n  --bg: #0a0c10;\n  --bg-card: #111318;\n  --bg-hover: #1a1d24;\n  --border: #1f2330;\n  --text: #e8eaf0;\n  --text-muted: #6b7280;\n  --text-dim: #9ca3af;\n  --accent: #4f8ef7;\n  --accent-hover: #3b7df6;\n  --accent-dim: rgba(79, 142, 247, 0.12);\n  --success: #34d399;\n  --warning: #fbbf24;\n  --danger: #f87171;\n  --font: 'DM Sans', sans-serif;\n  --mono: 'DM Mono', monospace;\n  --radius: 8px;\n  --radius-lg: 12px;\n}\n\nbody {\n  font-family: var(--font);\n  background: var(--bg);\n  color: var(--text);\n  font-size: 14px;\n  line-height: 1.6;\n  -webkit-font-smoothing: antialiased;\n}\n\na { color: inherit; text-decoration: none; }\nbutton { cursor: pointer; font-family: var(--font); }\ninput { font-family: var(--font); }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
